module.exports = __webpack_public_path__ + "static/img/170.d93e645a.png";